import { useItem } from './hooks/use-context';

export function OccurenceInfo() {
  const { sections } = useItem();

  return (
    <div
      style={{
        paddingTop: '30px',
        marginTop: '20px',
        breakInside: 'avoid',
        pageBreakInside: 'avoid',
      }}
    >
      <div
        style={{
          minHeight: '120px',
          width: '100%',
          backgroundColor: '#E0F4E9',
          padding: '10px',
          borderRadius: '6px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            width: '100%',
            minHeight: '100px',
            borderRadius: '6px',
            padding: '6px 10px',
            backgroundColor: '#FFFFFF',
          }}
        >
          {(() => {
            const infoQuestion = sections
              .flatMap((section) => section.questions)
              .find(
                (question) =>
                  question.question_id ===
                  '0c01e196-20e7-435a-ab98-b9dd07a3e6a1',
              );

            return (
              <div style={{ marginBottom: '1rem' }}>
                <strong>
                  1.1 - INFORMAÇÕES LEVANTADAS (Dados obtidos, observados ou
                  relatados após a ocorrência):
                </strong>
                <div style={{ marginTop: '0.5rem' }}>
                  {infoQuestion?.answers?.[0]?.content}
                </div>
              </div>
            );
          })()}

          {(() => {
            const providencesQuestion = sections
              .flatMap((section) => section.questions)
              .find(
                (question) =>
                  question.question_id ===
                  'b9948afe-6fda-4120-afa6-074789f01347',
              );

            return (
              <div style={{ marginBottom: '1rem', marginLeft: '1rem' }}>
                <strong>• PROVIDÊNCIAS:</strong>
                <div style={{ marginTop: '0.5rem' }}>
                  {providencesQuestion?.answers?.[0]?.content}
                </div>
              </div>
            );
          })()}
        </div>
      </div>
    </div>
  );
}
